import type { PainelResult } from '@obras/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '../../lib/api.js';

export const painelKeys = {
  all: ['painel'] as const,
};

/**
 * O painel não tem filtro, então não tem chave variável: uma leitura, a de
 * hoje. A anterior fica em tela enquanto a nova chega — design.md §9.
 */
export function usePainel(options: { enabled?: boolean | undefined } = {}) {
  return useQuery({
    queryKey: painelKeys.all,
    queryFn: ({ signal }) => api.get<PainelResult>('/painel', signal),
    placeholderData: (previous) => previous,
    enabled: options.enabled ?? true,
  });
}
